import { createContext, useContext } from "react";

export const RESERVED_PATHS = new Set([
  "", "login", "reset-password", "students", "users", "qr-codes",
  "reports", "alerts", "scan", "clients", "api", "static",
]);

const seg = (window.location.pathname.split("/")[1] || "").toLowerCase();
export const tenantSlug = RESERVED_PATHS.has(seg) ? "" : seg;

export const TenantContext = createContext(null);
export const useTenant = () => useContext(TenantContext);
